import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { CourseCategory } from './model/course-category.model';
import { Action, createReducer, on } from '@ngrx/store';
import { CourseCategoryActions } from './courseCategory.actions';

export const courseCategoryFeatureKey = 'courseCategory';

export const courseCategoryAdapter = createEntityAdapter<CourseCategory>();

export interface State extends EntityState<CourseCategory> {
    selectedCourseId: number;
}

export const initialState: State = courseCategoryAdapter.getInitialState({
    selectedCourseId: 0
});

const courseCategoryReducer = createReducer(
    initialState,
    on(CourseCategoryActions.loadCourseCategoriesSuccess, (state, { courseCategories }) => courseCategoryAdapter.addMany(courseCategories, { ...state, selectedCourseId: 0 })),
    on(CourseCategoryActions.createCourseCategorySuccess, (state, { courseCategory }) =>
        courseCategoryAdapter.addOne(courseCategory, { ...state, selectedCourseId: courseCategory.id || 0 })
    )
);

export function reducer(state: State | undefined, action: Action) {
    return courseCategoryReducer(state, action);
}
